export default {"src":"/_next/static/media/arrow-icon.3cd23951.svg","height":16,"width":19,"blurWidth":0,"blurHeight":0};